/**
 * Цели Метрики квиза (фаза 1, шаг 9) — одним списком на всё: квиз их шлёт,
 * скрипт вставки пропускает в счётчик сайта магазина только их, экран
 * настроек магазина называет их для заведения в своём счётчике. Разойдись
 * названия — магазин завёл бы цель, которую никто не шлёт.
 */
export const QUIZ_GOALS = {
  /** Первое касание квиза: выбрал группу или модель */
  start: 'skm_quiz_start',
  /** Заявка отправлена, код выдан */
  submit: 'skm_quiz_submit',
  /** Нажал «Открыть чат» на финале */
  messenger: 'skm_messenger_click',
} as const

export type QuizGoal = (typeof QUIZ_GOALS)[keyof typeof QUIZ_GOALS]

/**
 * Цели карточки и филиала (фаза 4): код заявки выдан. Только в счётчик
 * площадки — во фрейме на сайте магазина этих кнопок нет.
 */
export const MARKET_GOALS = {
  reserve: 'skm_reserve',
  notify: 'skm_notify',
  ask: 'skm_ask',
} as const

export const QUIZ_GOAL_LIST: readonly QuizGoal[] = Object.values(QUIZ_GOALS)

/**
 * Офлайн-цели площадки (фаза 3): приходят в счётчик площадки выгрузкой, а не
 * из браузера. Цель заводится в счётчике как «JavaScript-событие» с этим
 * идентификатором — иначе Метрика конверсию не примет.
 */
export const OFFLINE_GOALS = {
  /** Сделка заявки дошла до выкупа */
  buyout: 'skm_buyout',
} as const
